<template>
  <modal :title="$t('account_redesign.up_root_transfer_title')" :visible.sync='isShowDialog' width='600px'>
    <div class='warning-banner'>
      <i class='el-icon-warning'></i>
      <span>{{ $t('account_redesign.up_transfer_warning') }}</span>
    </div>
    <el-form
      ref='transferForm'
      :model='transferForm'
      :rules='transferRules'
      label-width='140px'
      label-position='right'
      class='transfer-form'
      @submit.native.prevent
    >
      <el-form-item :label="$t('account_redesign.up_transfer_to')" prop='targetUserId'>
        <el-select
          v-model='transferForm.targetUserId'
          :placeholder="$t('account_redesign.up_select_user')"
          style='width: 100%'
          filterable
          :loading='userLoading'
        >
          <el-option
            v-for='item in userOptions'
            :key='item.id'
            :label='item.account + (item.username ? " (" + item.username + ")" : "")'
            :value='item.id'
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('account_redesign.up_current_password')" prop='currentPassword'>
        <el-input
          v-model.trim='transferForm.currentPassword'
          type='password'
          show-password
          autocomplete='off'
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot='footer'>
      <el-button type='primary' @click='isShowDialog = false'>{{ $t('public.btn_close') }}</el-button>
      <el-button type='primary' :loading='submitLoading' @click='handleTransfer'>
        {{ $t('account_redesign.up_confirm_transfer') }}
      </el-button>
    </div>
  </modal>
</template>

<script>
import { listSubAccounts, transferRoot } from '@/api/modules/account.js'

export default {
  props: ['isShowTransfer', 'title'],
  computed: {
    isShowDialog: {
      get () {
        return this.isShowTransfer
      },
      set (val) {
        this.$emit('update:isShowTransfer', val)
      }
    },
    customerId () {
      // 优先从 vuex 获取当前用户企业的 customerId
      const userInfo = this.$store.getters.userInfo
      if (userInfo && userInfo.scope && userInfo.scope.customerId) {
        return userInfo.scope.customerId
      }
      if (userInfo && userInfo.scope && userInfo.scope.customerId) {
        return userInfo.scope.customerId
      }
      return localStorage.getItem('customerId') || ''
    }
  },
  data () {
    const validateUser = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('account_redesign.up_select_user')))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('account_redesign.up_current_password')))
      } else {
        callback()
      }
    }
    return {
      userLoading: false,
      userOptions: [],
      submitLoading: false,
      transferForm: {
        targetUserId: '',
        currentPassword: ''
      },
      transferRules: {
        targetUserId: [{ validator: validateUser, trigger: 'change' }],
        currentPassword: [{ validator: validatePassword, trigger: 'blur' }]
      }
    }
  },
  watch: {
    isShowDialog (val) {
      if (val) {
        this.fetchUsers()
        this.$nextTick(() => {
          if (this.$refs.transferForm) this.$refs.transferForm.resetFields()
        })
      }
    }
  },
  methods: {
    async fetchUsers () {
      this.userLoading = true
      try {
        const res = await listSubAccounts({
          start: 0,
          size: 500,
          customerId: this.customerId
        })
        if (res && res.state && res.state.code === 200) {
          const users = res.result || res.data || []
          const currentUserId = parseInt(localStorage.getItem('userId') || '0', 10)
          this.userOptions = users.filter(u => {
            // status 字段：1=启用, 0=禁用, 2=Pending, 3=Expire
            return u.status === 1 && u.id !== currentUserId
          })
        }
      } catch (e) {
        console.error('fetch users error:', e)
      } finally {
        this.userLoading = false
      }
    },
    async handleTransfer () {
      try {
        await this.$refs.transferForm.validate()
      } catch (e) {
        return
      }
      try {
        await this.$confirm(
          this.$t('account_redesign.up_transfer_warning'),
          this.$t('account_redesign.up_confirm_transfer'),
          {
            type: 'warning',
            confirmButtonText: this.$t('account_redesign.up_confirm_transfer'),
            cancelButtonText: this.$t('public.cancel')
          }
        )
      } catch (e) {
        return
      }
      this.submitLoading = true
      try {
        const res = await transferRoot({
          targetUserId: this.transferForm.targetUserId,
          currentPassword: this.transferForm.currentPassword
        })
        if (res && res.state && res.state.code === 200) {
          this.$message.success(this.$t('account_redesign.up_transfer_success'))
          this.isShowDialog = false
          localStorage.removeItem('token')
          localStorage.removeItem('userId')
          localStorage.removeItem('customerId')
          this.$router.replace('/login')
        }
      } catch (e) {
        console.error('transfer root error:', e)
      } finally {
        this.submitLoading = false
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.warning-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fdf6ec;
  border: 1px solid #f5dab1;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;

  i {
    color: #e6a23c;
    font-size: 18px;
    margin-top: 2px;
  }

  span {
    color: #b88230;
    font-size: 13px;
    line-height: 1.5;
  }
}

.transfer-form {
  ::v-deep .el-form-item__label {
    white-space: nowrap;
  }
}
</style>
